import { Card, Placeholder, Row, Col, Button, Spinner } from "react-bootstrap";
import MainCard from "../Cards/MainCard";

const ContentManagementSkeleton = () => {
  return (
    <MainCard>
      {/* Search + Filter */}
      <Row className="mb-3">
        <Col xs={12} md={9} className="mb-2 mb-md-0">
          <Placeholder as="input" animation="wave" className="form-control" />
        </Col>
        <Col xs={12} md={3}>
          <Placeholder as="select" animation="wave" className="form-select">
            <option>Loading...</option>
          </Placeholder>
        </Col>
      </Row>

      <div className="p-3 border rounded">
        {/* Table Rows Skeleton */}
        {[...Array(5)].map((_, i) => (
          <Row key={i} className="align-items-center mb-3 border-bottom pb-2">
            {/* Applicant */}
            <Col xs={3}>
              <div className="d-flex align-items-center gap-2">
                <Placeholder
                  as="div"
                  animation="wave"
                  className="rounded-circle bg-secondary"
                  style={{ width: "35px", height: "35px" }}
                />
                <Placeholder as="div" animation="wave" className="w-75">
                  <Placeholder xs={8} /> <Placeholder xs={6} />
                </Placeholder>
              </div>
            </Col>

            {/* Status */}
            <Col xs={2} className="text-center">
              <Placeholder.Button variant="secondary" xs={6} />
            </Col>

            {/* Experience */}
            <Col xs={2} className="text-center">
              <Placeholder as="div" animation="wave" className="w-50">
                <Placeholder xs={6} />
              </Placeholder>
            </Col>

            {/* License */}
            <Col xs={2} className="text-center">
              <Placeholder as="div" animation="wave" className="w-75">
                <Placeholder xs={8} />
              </Placeholder>
            </Col>

            {/* Background */}
            <Col xs={2} className="text-center">
              <Placeholder.Button variant="secondary" xs={8} />
            </Col>

            {/* Actions */}
            <Col xs={1} className="d-flex justify-content-center gap-2">
              <Spinner size="sm" animation="border" />
              {/* <Spinner size="sm" animation="border" /> */}
              {/* <Spinner size="sm" animation="grow" /> */}
            </Col>
          </Row>
        ))}
      </div>
    </MainCard>
  );
};

export default ContentManagementSkeleton;
